import React from "react";

const LatestOrders = ({ color = "#232323" }) => {
  return (
    <svg
      id="Raggruppa_1197"
      data-name="Raggruppa 1197"
      width="30.519"
      height="24.436"
      viewBox="0 0 30.519 24.436"
    >
      <rect
        id="Rettangolo_562"
        data-name="Rettangolo 562"
        width="14.43"
        height="1.257"
        transform="translate(8.698 11.413)"
        fill={color}
      />
      <rect
        id="Rettangolo_563"
        data-name="Rettangolo 563"
        width="14.43"
        height="1.257"
        transform="translate(8.698 7.19)"
        fill={color}
      />
      <rect
        id="Rettangolo_564"
        data-name="Rettangolo 564"
        width="14.43"
        height="1.257"
        transform="translate(8.698 15.687)"
        fill={color}
      />
      <path
        id="Tracciato_306"
        data-name="Tracciato 306"
        d="M4.777,0l-.1.05-.1.1L0,4.726l.5.5.05.05.1.1.1.1,3.469-3.52V17.6H5.28V1.961L8.749,5.48,9,5.229l.251-.251.051-.05.1-.1.1-.1Z"
        transform="translate(0 0)"
        fill={color}
      />
      <path
        id="Tracciato_307"
        data-name="Tracciato 307"
        d="M46.828,13.5h-.8V29.137l-3.47-3.469-.2.151-.05.1-.5.453,4.576,4.575.1.1.1.1.1-.1L51.3,26.372l-.2-.2-.05-.05-.252-.2-.15-.2-.05-.05-3.52,3.469V13.5Z"
        transform="translate(-20.783 -6.712)"
        fill={color}
      />
    </svg>
  );
};

export default LatestOrders;
